import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from '../../utils/reactRouterCompatibility';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMessage, fetchTicket, replyToTicket } from '../../../store/actions/SupportAction';
import Grid from '@mui/material/Grid';
import Loading from '../feeback/loading/Loading';
import { useTranslation } from 'react-i18next';
import Messages from './Messages';
import { TextField } from '@mui/material';
import Toolbar from './Toolbar';
import SelectDialog from './canned/SelectDialog';
import ReopenDialog from './ReopenDialog';
import Button from "../inputs/Button";
import FormRequiredField from '../feeback/FormRequiredField';

const Ticket = ({ onReplied, onClosed, box }) => {
	const dispatch = useDispatch();
	const { ticketId } = useParams();
	const { t } = useTranslation();

	const ticket = useSelector(state => state.support.ticket);
	const loading = useSelector(state => state.support.ticketLoading);
	const messages = useSelector(state => state.support.ticketMessages);
	const messagesLoading = useSelector(state => state.support.ticketMessagesLoading);
	const replying = useSelector(state => state.support.supportReplying);
	const hasRights = useSelector(state => state.support.support && state.access.support);

	const [message, setMessage] = useState('');
	const [showCannedDialog, setShowCannedDialog] = useState(false);
	const [showReopenDialog, setShowReopenDialog] = useState(false);

	const sendBtnEnabled = message.trim() !== '';

	const loadTicket = useCallback((id) => dispatch(fetchTicket(id)), [dispatch]);
	const loadMessages = useCallback((id) => dispatch(fetchMessage(id)), [dispatch]);

	useEffect(() => {
		loadTicket(ticketId);
	}, [ticketId, loadTicket]);

	useEffect(() => {
		if (!ticket) return;
		loadMessages(ticket.Support_Ticket__);
	}, [ticket, loadMessages]);

	const onCannedSelected = canned => {
		setMessage(canned.Message);
	};

	if (loading || messagesLoading || !ticket) return <Loading />;

	const handleSend = () => {
		if (message.trim() === '') return;
		dispatch(replyToTicket(ticketId, message.trim())).then(onReplied);
	};

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Toolbar ticket={ticket} onClosed={onClosed} box={box} />
			</Grid>

			<Grid item xs={12}>
				<Grid container direction="column" alignItems="stretch" spacing={2}>
					<Messages messages={messages} />
				</Grid>
			</Grid>

			{hasRights && (
				<>
					<FormRequiredField />
					<Grid item xs={12}>
						<TextField
							value={message}
							onChange={e => setMessage(e.target.value)}
							variant="outlined"
							multiline
							rows={4}
							maxRows={10}
							placeholder={t('support_response_placeholder')}
							required
							fullWidth
							disabled={replying}
							label={t('support_response_label')}
						/>
					</Grid>

					<Grid item xs={12}>
						<Grid justifyContent="space-between" container spacing={2}>
							<Grid item>
								<Button
									variant="outlined"
									disabled={replying}
									onClick={() => setShowCannedDialog(true)}
								>
									{t('canned_btn')}
								</Button>
							</Grid>
							<Grid item>
								<Button
									variant="contained"
									loading={replying}
									disabled={!sendBtnEnabled || replying}
									color="primary"
									onClick={() => ticket.Status !== 'closed' ? handleSend() : setShowReopenDialog(true)}
								>
									{t('send_btn')}
								</Button>
							</Grid>
						</Grid>
					</Grid>

					<SelectDialog
						setOpen={setShowCannedDialog}
						open={showCannedDialog}
						onSelected={onCannedSelected}
					/>
					<ReopenDialog
						open={showReopenDialog}
						setOpen={setShowReopenDialog}
						ticket={ticket}
						message={message.trim()}
						onTicketSend={onReplied}
					/>
				</>
			)}
		</Grid>
	);
};

export default Ticket;
